const maxNumberOfBins = 15;
const regressionsKmSplit = 10000; // i.e. split the 2 regression lines at 10,000 km

export {
  maxNumberOfBins,
  regressionsKmSplit,
};
